import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { RouterStore } from '@route/data-access';
import { AuthStore } from '@auth/data-access';
import { APP_CONFIG } from '@application/config';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export const DomainGuard: CanActivateFn = () => {

  const authStore = inject(AuthStore);
  const routerStore = inject(RouterStore);
  const appConfig = inject(APP_CONFIG);

   if (!authStore.isLoggedIn()) {

     if (!Capacitor.isNativePlatform()) {
      if (!window.location.hostname.includes('localhost')) {
        const currentHostname = window.location.hostname.split('.').slice(1).join('.');
        const appUrl = `${window.location.protocol}//accounts.${currentHostname}`
        location.href = appUrl;
      } else {
        const appUrl = appConfig.appUrl.accounts
        location.href = appUrl;
      }
    }

    if (Capacitor.isNativePlatform()) {
      routerStore.navigate(['/onboarding']);
      if (!window.location.hostname.includes('localhost')) {
        const currentHostname = window.location.hostname.split('.').slice(1).join('.');
        const appUrl = `${window.location.protocol}//accounts.${currentHostname}`
        Browser.open({ url: appUrl }).then();
      } else {
        const appUrl = appConfig.appUrl.accounts
        Browser.open({ url: appUrl }).then();
      }
    }

   }
   return authStore.isLoggedIn();
};
